<spt-component-container [setLoadComponentRef]="cmpRef.componentRef$ | ngrxPush"></spt-component-container>
